import $ from 'jquery';
import Mustache from 'mustache';
import moment from 'moment';
import {__} from "../libraries/translations.ts";

moment.locale('nl');

export class ListResultView {

    container;
    paginationContainer;
    paginationOptionContainer;

    page = 1;
    pages = 10;
    visiblePages = 4;

    favoriteClicked;
    triggerFind;
    triggerClick;

    calendarLocales;

    constructor(container, paginationOptionContainer, paginationContainer) {
        this.container = container;
        this.paginationContainer = paginationContainer;
        this.paginationOptionContainer = paginationOptionContainer;
        this.calendarLocales = __('moment')['calendar'];

        this.loadPagination();
    }

    onFavoriteClicked(method) {
        this.favoriteClicked = method;
    }

    onTriggerFind(method) {
        this.triggerFind = method;
    }

    onClick(method) {
        this.triggerClick = method;
    }

    show() {
        if (Array.isArray(this.container)) {
            return;
        }
        this.container.show();
        this.paginationOptionContainer.show();
    }

    hide() {
        if (Array.isArray(this.container)) {
            return;
        }
        this.container.hide();
        this.paginationOptionContainer.hide();
    }

    putActivities(response, layoutName) {
        this.pages = response.last_page;
        let items = response.data;
        if(layoutName === 'events-list') {
            items = items.filter(item => !item.isAdvertisement);
        }

        response.data = this.applyGrouping(items, layoutName);
        if (Array.isArray(this.container)) {
            this.putActivitiesForHomepage(response, layoutName);
            return;
        }

        const html = Mustache.render(this.getLayout(layoutName), response);
        this.container.html(html);

        this.loadPagination();
        this.bindButtons();
    }

    bindButtons() {
        this.container.find('.btn-favorite').click((event) => this.favoriteClicked(event));
        this.container.find('.mos-selectable').click((event) => this.triggerClick(event));
    }

    getSearchAttributes() {
        return {
            page: this.page
        };
    }

    loadPagination() {
        // reset container
        this.paginationContainer.find(':first').twbsPagination('destroy');
        this.paginationContainer.empty();
        this.paginationContainer.append('<span></span>');

        // create new paginator
        this.paginationContainer.find(':first').twbsPagination({
            startPage: this.page,
            totalPages: this.pages,
            visiblePages: this.visiblePages,
            onPageClick: (event, page) => {
                if (this.page !== page) {
                    this.page = page ?? 1;
                    this.triggerFind();

                    // scroll to top
                    $("html, body").animate({scrollTop: 0}, 'fast');
                }
            },
            paginationClass: "pagination justify-content-end"
        });
    }

    applyGrouping(data, layout) {
        if (layout === 'events-list' && data.length > 0) {
            const first = data[0];
            if (!first.hasOwnProperty('startDateTime') || !first.hasOwnProperty('endDateTime')) {
                data = [{
                    date: undefined,
                    dateFormatted: undefined,
                    items: data
                }];
            } else {
                data = this.applyListGrouping(data);
            }
        }

        return data;
    }

    applyListGrouping(data) {
        data = this._groupBy(data, 'day');
        let newData = [];
        for (let key in data) {
            const item = data[key];
            const date = item[0].startDateTimeObj;
            let dateFormatted = date.calendar(null, this.calendarLocales);
            dateFormatted = dateFormatted.charAt(0).toUpperCase() + dateFormatted.slice(1)
            newData.push({
                date: dateFormatted,
                dateFormatted: dateFormatted,
                items: item
            });
        }

        return newData;
    }

    _groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    getLayout(layoutName) {
        return $('#' + layoutName).html();
    }

    putActivitiesForHomepage(response, layoutName) {
        const containers = this.container.length;
        const countAll = response.data.length;
        if (containers === 0 || countAll === 0) {
            return;
        }

        const perPage = Math.round(countAll / containers);

        for (let i = 0; i < containers; i++) {
            const data = JSON.parse(JSON.stringify(response));
            const container = this.container[i];
            data.data = data.data.slice(perPage * i, perPage * (i + 1));

            const html = Mustache.render(this.getLayout(layoutName), data);
            container.html(html);
            container.find('.btn-favorite').click((event) => this.favoriteClicked(event));
        }
    }
}
